import _ from 'underscore';

const getCurrentStatus = (timeline) => {
  const statuses = _.values(timeline);
  const chronological_statuses = _.sortBy(statuses, function (s) {
    return -s.status.code;
  });
  const latest = _.first(chronological_statuses);
  return latest.status.message;
};

const getCurrentStatusCode = (timeline) => {
  const statuses = _.values(timeline);
  const chronological_statuses = _.sortBy(statuses, function (s) {
    return -s.status.code;
  });
  const latest = _.first(chronological_statuses);
  return latest.status.code;
};

export { getCurrentStatus, getCurrentStatusCode };
